import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import styles from './BackArrow.module.scss';

interface BackArrowProps {
    url?: string,
    text?: string
}

export const BackArrowDarkBlue = ({ url, text } : BackArrowProps) => {
    const history = useHistory();
    const { t } = useTranslation();
    
    const displayText = text ? text : t('Util.Back');
    
    if (url) {
        return (
            <Link to={url} aria-label={displayText}>
                <span className={`${styles.container} ${styles.containerCenter}`}>
                    <span className={`${styles.arrow_container} ${styles.arrowImg}`} aria-hidden="true"></span>
                    <span className={styles.arrowText}>{displayText}</span>
                </span>
            </Link>
        )
    } else {
        return (
            <button 
                type="button"
                onClick={() => history.goBack()}
                className={styles.backButton}
                aria-label={displayText}
            >
                <span className={styles.container}>
                    <span className={`${styles.arrow_container} ${styles.arrowImg}`} aria-hidden="true"></span>
                    <span className={styles.arrowText}>{displayText}</span>
                </span>
            </button>
        )
    }
};